import { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { loginUser } from '../../services/auth.service';
import { ROLES } from '../../utils/roles';
import PasswordField from '../../components/PasswordField/PasswordField';
import './Auth.scss';

const Login = () => {
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { setUser } = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const redirectTo = searchParams.get('redirect');

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await loginUser(formData);
      localStorage.setItem('token', response.data.token);
      localStorage.setItem('loginTimestamp', Date.now().toString());
      const userData = response.data.user;
      setUser(userData);
      const isPartnerUser = String(userData.role || '').trim() === ROLES.PARTNER;
      let targetPath =
        redirectTo && redirectTo.startsWith('/') && !redirectTo.startsWith('//') ? redirectTo : '/';
      if (isPartnerUser) {
        const pathOnly = (targetPath.split('?')[0] || '').trim();
        const allowed =
          pathOnly === '/formular-center' ||
          pathOnly.startsWith('/formular-center/') ||
          pathOnly === '/settings' ||
          pathOnly.startsWith('/settings/');
        if (!allowed) targetPath = '/formular-center';
      }
      navigate(targetPath, { replace: true });
    } catch (err) {
      if (!err.response) {
        setError('Server nicht erreichbar. Bitte später erneut versuchen oder Administrator informieren.');
        return;
      }
      const msg = err.response?.data?.message;
      if (msg) {
        setError(msg);
        return;
      }
      if (Array.isArray(err.response?.data?.errors) && err.response.data.errors[0]?.msg) {
        setError(err.response.data.errors[0].msg);
        return;
      }
      setError('Login fehlgeschlagen');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-container">
        <h2>Anmelden</h2>
        <form onSubmit={handleSubmit} className="auth-form">
          {error && <div className="form-error">{error}</div>}
          
          <div className="form-group">
            <input
              type="email"
              id="email"
              name="email"
              className="form-input"
              placeholder="E-Mail"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <PasswordField
              id="password"
              name="password"
              placeholder="Passwort"
              value={formData.password}
              onChange={handleChange}
              required
              autoComplete="current-password"
            />
          </div>

          <button
            type="submit"
            className="btn btn--primary btn--full-width"
            disabled={loading}
          >
            {loading ? 'Lädt...' : 'Anmelden'}
          </button>
        </form>

  
      </div>
    </div>
  );
};

export default Login;
